/*jshint esversion: 6 */
const { serverSideRender: ServerSideRender } = wp;
import { Component } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
class TecSliderBlock extends Component {
    constructor(props, context) {
        super(props, context);
        this.content = '';
    }
    componentDidMount( prevProps, prevState ) {
        apiFetch( {
            path: "/tecslider/v1/events/",
            method: "POST",
            data: this.props.options,
        } ).then( ( res ) => {
            this.content = res.content;
        } );
    }
    render() {
        let options = this.props.options;
        this.state='touched';
        return (
            <div>
                <ServerSideRender
                    block="tecslider/tecsb-slider-block"
                    attributes={ options }
                    onRender={
                        setTimeout(
                            () => triggerSlider(this.props.options),
                            2000
                        )
                    }
                />
                {/* <div>
                    {this.content}
                </div> */}
            </div>
        );
    }
}
export default TecSliderBlock;